<template>
    <div class="box">
        <div class="box-offset">
            <h3 class="ttl-underline">Summary</h3>
            <div class="rented-boat-details-wrap">
                <div class="rented-boat-details">
                    <a :href="boat.url" class="prod-link">
                        <img :src="boat.image" alt="boat_image">
                    </a>
                    <div >
                        <div class="row">
                            <div class="col-6">
                                <div class="rented-time">{{ info.duration }} hours</div>
                            </div>
                            <div class="col-6 text-right">
                                <div class="ammount">${{ info.price }}</div>
                            </div>
                            <div class="col-12 mt-3">
                                <h6>{{ boat.name }}</h6>
                            </div>
                        </div>
                    </div>
                </div>
                <small class="mb-4">Rate includes FL sales tax and credit card processing fee (10%).</small>
                <div class="row">
                    <div class="col-7">
                        <p><i class="fas fa-calendar-alt"></i>{{ info.starts_at_formatted }}</p>
                    </div>
                    <div class="col-5 text-right">
                        <a :href="boat.url" class="link">Change Details</a>
                    </div>
                </div>
            </div>

            <div class="separation-small"></div>

            <h6>Add to your appointment</h6>
            <div class="form-group" v-for="addon in addons" :key="addon.id">
                <div class="form-check">
                    <input class="form-check-input-checkbox" type="checkbox" :id="addon.name" v-model="addon.value">
                    <label class="form-check-label" :for="addon.name">
                        {{ addon.description }}
                    </label>
                </div>
            </div>

            <div class="separation-small"></div>
            <h6>Add Coupon</h6>

            <form class="promocode-input" action="#" method="post">
                <input type="text" placeholder="Enter Promo Code" class="form-control" v-model="promoCode">
                <button type="submit" @click.prevent="submitPromoCode">Apply</button>
            </form>

            <div class="separation"></div>

            <div class="total-cost">
                <div class="row">
                    <div class="col-6 ">
                        <p>Subtotal:</p>
                    </div>
                    <div class="col-6 text-right">
                        <p>
                            {{ subTotal | toFixed | toUSD }}
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 ">
                        <p>Discount:</p>
                    </div>
                    <div class="col-6 text-right">
                        <p>
                            {{ getDiscount | toFixed | toUSD }}
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 ">
                        <p>Taxes & Fees:</p>
                    </div>
                    <div class="col-6 text-right">
                        <p>
                            {{ getTaxes | toFixed | toUSD }}
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 ">
                        <p>Total:</p>
                    </div>
                    <div class="col-6 text-right">
                        <p>
                            <strong>
                                {{ getTotal | toFixed | toUSD }}
                            </strong>
                        </p>
                    </div>
                </div>
            </div>

            <form class="box-offset" id="bookingForm" ref="bookingForm" method="post" :action="`/order/booking?promo=${this.promoCode}`"></form>

            <button class="btn w-100" @click="validate">Save and continue</button>
        </div>
    </div>
</template>

<script>
    import swalMessages from "../../../../../../../resources/js/mixins/swal-messages";
    import promoCode from "../../../../../../../resources/js/mixins/promo-code";

    export default {
        name: "BookingSummary",
        mixins: [ swalMessages, promoCode ],
        props: {
            boat: {
                type: Object
            },
            info: {
                type: Object
            },
            cdwPrice: Number,
            captainPrice: Number,
        },
        data() {
            return {
                total: this.info.price,
                subTotal: this.info.price,
                taxes: {
                    amount: 10,
                    type: 'PERCENTAGE'
                },
                addons: [
                    {
                        id: 1,
                        price: this.cdwPrice,
                        name: 'cdw',
                        value: false,
                        description: 'Collision Damage Waiver (CDW) for damage to the propeller ($200 replacement cost without the waiver) $' + this.cdwPrice,
                    },
                    {
                        id: 2,
                        price: this.captainPrice,
                        name: 'captain',
                        value: false,
                        description: 'Hire Captain (+$'+this.captainPrice+', subject to availability). Captain fee to be paid directly to the captain in cash on day of rental.',
                    }
                ],
            }
        },
        computed: {
            getAddedAddonsValue() {
                return this.addons
                    .filter((addon) => !!addon.value && addon.name === 'cdw')
                    .reduce((acc, addon) => acc + addon.price, 0)
            },
            getDiscount() {
                const promoAmount = this.promo?.amount || 0;

                return (this.subTotal * promoAmount / 100);
            },
            getSubtotalWithDiscount() {
                return this.subTotal - this.getDiscount;
            },
            getTaxes() {
                return this.taxes.type === 'PERCENTAGE' &&
                    (this.getSubtotalWithDiscount * this.taxes.amount / 100);
            },
            getTotal() {
                return (this.subTotal - this.getDiscount + this.getTaxes) + this.getAddedAddonsValue;
            }
        },
        methods: {
            validate() {
                const { bookingForm } = this.$root.$refs
                const { form } = bookingForm.$refs;

                bookingForm.resetAnimation();

                (async () => {
                    const valid = await form.validate();
                    const errors = [];

                    for (const key in form.errors) {
                        if (form.errors.hasOwnProperty(key)) {
                            if (form.errors[key].length) {
                                if (key.includes('Children')) {
                                    if (!errors.includes('Children')) errors.push('Children')
                                } else {
                                    errors.push(key);
                                }
                            }
                        }
                    }

                    if (valid) this.submit();
                    if (!valid) this.showValidationErrorMessage(errors);
                })();
            },
            submit() {
                const { bookingForm } = this.$root.$refs
                const { boat, info } = bookingForm;
                const data = bookingForm._data.form;

                const form = $('#bookingForm');

                const token = $("<input>").attr("type", "hidden").attr("name", "_token").val($('meta[name="csrf-token"]').attr('content'));
                form.append(token);
                for (const [key, value] of Object.entries(data)) {
                    form.append($("<input>").attr("type", "hidden").attr("name", key).val(value));
                }
                for (const [key, value] of Object.entries(this.promo)) {
                    form.append($("<input>").attr("type", "hidden").attr("name", `promo[${key}]`).val(value));
                }
                form.append($("<input>").attr("type", "hidden").attr("name", 'discount').val(this.getDiscount));
                form.append($("<input>").attr("type", "hidden").attr("name", 'total').val(this.getTotal));
                form.append($("<input>").attr("type", "hidden").attr("name", 'subTotal').val(this.subTotal));
                for (const [key, value] of Object.entries(info)) {
                    form.append($("<input>").attr("type", "hidden").attr("name", `info[${key}]`).val(value));
                }
                form.append($("<input>").attr("type", "hidden").attr("name", 'boat_id').val(boat.id));

                let addons = this.addons.filter((addon => !!addon.value))

                for (let i = 0; i < addons.length; i++) {
                    for (const [key, value] of Object.entries(addons[i])) {
                        form.append($("<input>").attr("type", "hidden").attr("name", `addons[${i}][${key}]`).val(value));
                    }
                }

                form.submit();
            },
        }
    }
</script>

<style scoped>
    .form-check-label:hover {
        cursor: pointer;
    }

    .boat-inner-page .summary-block .total-cost strong {
        font-size: 1.25rem;
    }
</style>
